import {Injectable } from "@angular/core";

import {ValApiResultat, ValBaseService} from "../../../val-services-communs-lib/src/public-api";
import {ValAppSettingsService} from "../../../val-app-settings-lib/src/public-api";
import {AsParametresClient} from "./AsRetournerParametresClient";
import {parametresClient} from "../../../../val-definitions-communes-lib/src/public-api";

//Servics client
@Injectable (
{
  providedIn: 'root'
})
export class ServicesClientService extends ValBaseService 
{
  //Création
  //  Paramètres
  //    appSettingsService : Service d’accès à la configuration de l’application
  constructor (private appSettingsService: ValAppSettingsService) 
  {
    super ();
  }

  //Url de base
  protected override get BaseUrl () : string 
  {
    return `${this.appSettingsService.Configuration.UrlApi.Services}/v1.0/client/`;
  }

  //Retourne les paramètres du client
  //  Retourne
  //    Résultat de la récupération des paramètres du client
  public async RetournerParametresClient () : Promise<ValApiResultat<AsParametresClient>> 
  {
    let operation: Promise<ValApiResultat<AsParametresClient>>;
    let url: string;

    url = `${parametresClient.code}/parameters`;
    
    operation = this.ExecuterRequeteGet<AsParametresClient> (url);

    return operation
  }
}
